import React, {FC} from 'react';

interface TitleCardSectionProps {
  title: string;
  subtitle: string;
}

const TitleCardSection: FC<TitleCardSectionProps> = ({title,  subtitle}) => {

  return (
      <div className="mb-6">
        <h3 className="text-3xl lg:text-2xl font-semibold text-neutral-900 dark:text-neutral-100">
          {title}
        </h3>
        <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-2">
          {subtitle}
        </p>
      </div>
  );
};

export default TitleCardSection;


